import React, { Component } from 'react';
import DefaultGrid from '../../../components/DefaultGrid';
import CrudForm from '../../../template/CrudForm';
import Form, { SimpleItem, GroupItem } from 'devextreme-react/form';
import {
	showSuccessMessage,
	showConfirmationMessage,
	handleError,
	formatNumberDecimalPlaces,
} from '../../../utils/Utility';
import * as messages from '../../../utils/Messages';
import '../../../utils/Messages';
import API, {
	shipDataSource,
	productDataSource,
	customerDataSource,
	companyShippingDataSource,
} from '../../../services/AplicationService';

const masterProps = {
	title: 'Cadastro de Rotas de Carregamento',
	subtitle: 'Gerencie o cadastro de rotas de carregamento',
};
const initialState = {
	logisticRoute: {
		id: null,
		nickName: '',
		description: '',
		senderId: null,
		recipientId: null,
		productId: null,
		maximumLoadWeight: null,
		shippingCompanyId: null,
		enabled: true,
		totalWeightTransported: 0,
		ballanceWeight: 0,
	},
	term: '',
};
export default class LogisticRoute extends Component {
	state = { ...initialState };
	logisticRoute = {
		id: null,
		nickName: '',
		description: '',
		senderId: null,
		recipientId: null,
		productId: null,
		maximumLoadWeight: null,
		shippingCompanyId: null,
		enabled: true,
		totalWeightTransported: 0,
		ballanceWeight: 0,
	};
	constructor(props) {
		super(props);
		this.loadListLogisticRoutes = this.loadListLogisticRoutes.bind(this);
		this.getLogisticRoute = this.getLogisticRoute.bind(this);
		this.deleteLogisticRoute = this.deleteLogisticRoute.bind(this);
		this.onClickSearch = this.onClickSearch.bind(this);
		this.onClickNew = this.onClickNew.bind(this);
		this.onClickSave = this.onClickSave.bind(this);
		this.setStateDataToInitial = this.setStateDataToInitial.bind(this);
		this.saveLogisticRoute = this.saveLogisticRoute.bind(this);
		this.dataGrid = React.createRef();
		this.crudForm = React.createRef();
		this.form = React.createRef();
	}
	getLogisticRoute(key) {
		this.crudForm.current.showLoadingPanel(true);
		API.get('logisticRoutes/' + key)
			.then(response => {
				this.logisticRoute = { ...response.data };
				this.setState({ ...this.state, logisticRoute: this.logisticRoute });
				this.crudForm.current.setActiveTabIndex(1);
			})
			.catch(error => {
				handleError(error, messages.errorGetData);
			})
			.then(() => {
				this.crudForm.current.showLoadingPanel(false);
			});
	}
	deleteLogisticRoute(key) {
		API.delete('logisticRoutes/' + key)
			.then(response => {
				showSuccessMessage(messages.successDeleteData);
				this.setStateDataToInitial();
				this.dataGrid.current.reloadData();
			})
			.catch(error => {
				handleError(error, messages.errorDeleteData);
			});
	}
	saveLogisticRoute() {
		this.crudForm.current.showLoadingPanel(true);
		let logisticRoute = { ...this.logisticRoute };
		if (logisticRoute.id === null) {
			API.post('logisticRoutes/', logisticRoute)
				.then(response => {
					showSuccessMessage(messages.successInsertData);
					logisticRoute = response.data;
					this.logisticRoute = logisticRoute;
					this.setState({ logisticRoute: this.logisticRoute });
					// console.log(this.logisticRoute);
					//this.setStateDataToInitial();
					this.dataGrid.current.reloadData();
				})
				.catch(error => {
					handleError(error, messages.errorInsertData);
					this.dataGrid.current.reloadData();
				})
				.then(() => {
					this.crudForm.current.showLoadingPanel(false);
				});
		} else {
			API.put('logisticRoutes/' + logisticRoute.id, logisticRoute)
				.then(response => {
					showSuccessMessage(messages.successUpdateData);
					this.logisticRoute = logisticRoute;
					this.setState({ logisticRoute: this.logisticRoute });
					this.dataGrid.current.reloadData();
				})
				.catch(error => {
					handleError(error, messages.errorUpdateData);
				})
				.then(() => {
					this.crudForm.current.showLoadingPanel(false);
				});
		}
	}
	loadListLogisticRoutes(page, pageSize) {
		let term = this.state.term;
		return API.get('/logisticRoutes', {
			params: {
				page: page,
				pageSize: pageSize,
				term: term
		
			},
		})
			.then(response => {
				let result = {
					data: response.data.logisticRoutes,
					totalCount: response.data.totalRegisters,
				};

				return result;
			})
			.catch(error => {
				handleError(error, messages.errorListData);
			});
	}
	renderGrid() {
		return (
			<React.Fragment>
				<DefaultGrid
					ref={this.dataGrid}
					pageSize={50}
					keyField={'id'}
					showBorders={true}
					fncDeleteData={this.deleteLogisticRoute}
					fncGetData={this.getLogisticRoute}
					fncListData={this.loadListLogisticRoutes}
					defaultColumns={[
						{ dataField: 'id', caption: 'Código', width: '5%' },
						{ dataField: 'nickName', caption: 'Apelido' },
						{ dataField: 'shippingCompany', caption: 'Transportadora' },
						{ dataField: 'sender', caption: 'Remetente' },
						{ dataField: 'recipient', caption: 'Destinatário' },
						{
							dataField: 'maximumLoadWeight',
							caption: 'Peso Máximo',
							calculateCellValue: function(data) {
								var formatedValue = formatNumberDecimalPlaces(data.maximumLoadWeight, 0);
								if (formatedValue) return formatedValue + ' Kg';
								else return '';
							},
						},
						{
							dataField: 'totalWeightTransported',
							caption: 'Peso Transportado',
							calculateCellValue: function(data) {
								var formatedValue = formatNumberDecimalPlaces(data.totalWeightTransported, 0);
								if (formatedValue) return formatedValue + ' Kg';
								else return '';
							},
						},
						{
							dataField: 'countTransportLogisticRoute',
							caption: 'Qtd. Ordens Carregamento',
	
						},
						{
							dataField: 'ballanceWeight',
							caption: 'Saldo para Transporte',
							calculateCellValue: function(data) {
								var formatedValue = formatNumberDecimalPlaces(data.ballanceWeight, 0);
								if (formatedValue) return formatedValue + ' Kg';
								else return '';
							},
						},
						{ dataField: 'enabled', caption: 'Ativo', width: '10%' },
					]}
					buttons={[
						{
							name: 'edit',
							hint: 'delete',
							icon: 'fa fa-edit',
							visible: true,
						},
						{
							name: 'delete',
							hint: 'Excluir',
							icon: 'fa fa-trash',
							visible: true,
						},
					]}
				/>
			</React.Fragment>
		);
	}
	setStateDataToInitial() {
		this.logisticRoute = { ...initialState.logisticRoute };
		this.setState({ ...this.state, logisticRoute: this.logisticRoute });
	}
	onClickSearch = function(e) {
		this.dataGrid.current.reloadData();
	};
	onClickSave = function() {
		this.saveLogisticRoute();
	};
	onClickNew = function() {
		showConfirmationMessage(messages.questionNewOperation, this.setStateDataToInitial);
	};
	renderFilter() {
		return (
			<Form formData={this.state} colCount={7}>
				<GroupItem colSpan={6}>
					<SimpleItem
						dataField={'term'}
						cssClass="uppercase"
						editorOptions={{ placeholder: 'Digite o que deseja procurar...' }}
						label={{ text: 'Buscar por', showColon: false, visible: false }}
					/>
				</GroupItem>
				<GroupItem>
					<button onClick={this.onClickSearch} type="button" className="btn btn-info btn-block">
						<i className="fa fa-search" />
						&nbsp; Buscar
					</button>
				</GroupItem>
			</Form>
		);
	}
	renderForm() {
		return (
			<Form
				formData={this.logisticRoute}
				alignItemLabels={true}
				alignItemLabelsInAllGroups={true}
				ref={this.form}
				showColonAfterLabel={false}
				labelLocation={'left'}
			>
				<GroupItem colCount={5} alignItemLabels={true} alignItemLabelsInAllGroups={true}>
					<SimpleItem
						dataField={'id'}
						cssClass="uppercase"
						label={{ text: 'Código' }}
						editorOptions={{ disabled: true }}
					/>
					<SimpleItem dataField={'enabled'} editorType={'dxCheckBox'} label={{ text: 'Ativo' }} colSpan={4} />
					<SimpleItem colSpan={4} dataField={'nickName'} cssClass="uppercase" label={{ text: 'Apelido' }} />
					<SimpleItem
						dataField={'maximumLoadWeight'}
						editorOptions={{
							min: 0,
							max: 9000000000000,
							format: '#,##0 kg',
							// disabled: this.logisticRoute.id ? true : false,
						}}
						colSpan={1}
						editorType={'dxNumberBox'}
						cssClass="uppercase"
						label={{ text: 'Peso Máximo' }}
					/>

					<SimpleItem
						colSpan={5}
						dataField={'shippingCompanyId'}
						editorType={'dxSelectBox'}
						cssClass="uppercase"
						editorOptions={{
							dataSource: companyShippingDataSource,
							searchEnabled: true,
							valueExpr: 'id',
							displayExpr: 'corporateName',
							searchModeOption: 'contains',
							searchTimeoutOption: 200,
							minSearchLengthOption: 2,
							showDataBeforeSearchOption: false,
						}}
						label={{ text: 'Transportadora' }}
					/>

					<SimpleItem
						dataField={'senderId'}
						editorType={'dxSelectBox'}
						cssClass="uppercase"
						colSpan={5}
						editorOptions={{
							dataSource: customerDataSource,
							searchEnabled: true,
							valueExpr: 'id',
							displayExpr: 'corporateName',
							searchModeOption: 'contains',
							searchTimeoutOption: 200,
							minSearchLengthOption: 2,
							showDataBeforeSearchOption: false,
						}}
						label={{ text: 'Remetente' }}
					/>
					<SimpleItem
						dataField={'recipientId'}
						editorType={'dxSelectBox'}
						cssClass="uppercase"
						colSpan={5}
						editorOptions={{
							dataSource: customerDataSource,
							searchEnabled: true,
							valueExpr: 'id',
							displayExpr: 'corporateName',
							searchModeOption: 'contains',
							searchTimeoutOption: 200,
							minSearchLengthOption: 2,
							showDataBeforeSearchOption: false,
						}}
						label={{ text: 'Destinatário' }}
					/>
					<SimpleItem
						dataField={'productId'}
						editorType={'dxSelectBox'}
						cssClass="uppercase"
						colSpan={3}
						editorOptions={{
							dataSource: productDataSource,
							searchEnabled: true,
							valueExpr: 'id',
							displayExpr: 'name',
							searchModeOption: 'contains',
							searchTimeoutOption: 200,
							minSearchLengthOption: 2,
							showDataBeforeSearchOption: false,
						}}
						label={{ text: 'Produto' }}
					/>
					<SimpleItem
						dataField={'shipId'}
						editorType={'dxSelectBox'}
						cssClass="uppercase"
						colSpan={2}
						editorOptions={{
							dataSource: shipDataSource,
							searchEnabled: true,
							valueExpr: 'id',
							displayExpr: 'name',
							searchModeOption: 'contains',
							searchTimeoutOption: 200,
							minSearchLengthOption: 2,
							showDataBeforeSearchOption: false,
						}}
						label={{ text: 'Navio' }}
					/>

					<SimpleItem
						colSpan={5}
						dataField={'description'}
						editorType={'dxTextArea'}
						editorOptions={{ inputAttr: { rows: 8 } }}
						label={{ text: 'Mais Informações' }}
					/>
				</GroupItem>
				<GroupItem colCount={4}>
					<SimpleItem colSpan={2} />
					<SimpleItem
						dataField={'totalWeightTransported'}
						editorOptions={{
							min: 0,
							max: 9000000000000,
							format: '#,##0 kg',
							disabled: true,
						}}
						colSpan={1}
						editorType={'dxNumberBox'}
						cssClass="uppercase"
						label={{ text: 'Peso Transportado' }}
					/>
					<SimpleItem
						dataField={'ballanceWeight'}
						editorOptions={{
							min: 0,
							max: 9000000000000,
							format: '#,##0 kg',
							disabled: true,
						}}
						colSpan={1}
						editorType={'dxNumberBox'}
						cssClass="uppercase"
						label={{ text: 'Saldo para Transporte' }}
					/>
				</GroupItem>
				<GroupItem>
					<div className="pull-right">
						<button type="button" className="btn btn-right-space btn-primary" onClick={this.onClickNew}>
							<i className="fa fa-plus" />
							&nbsp; Novo
						</button>
						<button type="button" className="btn btn-success" onClick={this.onClickSave}>
							<i className="fa fa-check" />
							&nbsp; Salvar
						</button>
					</div>
				</GroupItem>
			</Form>
		);
	}
	render(props) {
		masterProps.form = this.renderForm();
		masterProps.dataGrid = this.renderGrid();
		masterProps.filter = this.renderFilter();
		return <CrudForm {...masterProps} ref={this.crudForm} />;
	}
}
